import React from "react";
import { Link } from "react-router-dom";

const DashboardBalanceButton: React.FC = () => {
    return (
        <Link to="/home/dashboard/balance" className="btn btn-outline-primary">
            Manage Money and Minutes
        </Link>
    );
};

export default DashboardBalanceButton;
